import * as React from "react";

function BimboIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 80 28"
    >
      <defs>
        <clipPath>
          <rect width="80" height="28" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-bimbo)">
        <path
          data-name="Path 7057"
          d="M-20.894-4.318a3.716,3.716,0,0,1-1.547,3.19A7.175,7.175,0,0,1-26.738,0h-7.573V-15.136h6.929a7.516,7.516,0,0,1,4.195.961,3.207,3.207,0,0,1,1.423,2.841,3.355,3.355,0,0,1-.714,2.175,3.659,3.659,0,0,1-2.175,1.2,4.655,4.655,0,0,1,2.8,1.155A3.32,3.32,0,0,1-20.894-4.318ZM-24.955-10.9a1.607,1.607,0,0,0-.65-1.45,3.52,3.52,0,0,0-1.928-.43h-3.609v3.749h3.631a3.219,3.219,0,0,0,1.95-.467A1.659,1.659,0,0,0-24.955-10.9Zm.881,6.338q0-2.127-3.051-2.127h-4.018v4.34h4.136a3.609,3.609,0,0,0,2.229-.553A1.982,1.982,0,0,0-24.074-4.565ZM-18.864,0V-15.136h3.169V0ZM-.623,0V-9.174q0-.312.005-.623t.1-2.675q-.763,2.89-1.128,4.028L-4.372,0H-6.628L-9.356-8.443l-1.149-4.028q.129,2.492.129,3.3V0h-2.814V-15.136h4.243l2.707,8.465L-6-5.854l.516,2.03.677-2.428,2.782-8.884H2.191V0ZM18.112-4.318a3.716,3.716,0,0,1-1.547,3.19A7.175,7.175,0,0,1,12.268,0H4.695V-15.136h6.929a7.516,7.516,0,0,1,4.195.961,3.207,3.207,0,0,1,1.423,2.841,3.355,3.355,0,0,1-.714,2.175,3.659,3.659,0,0,1-2.175,1.2,4.655,4.655,0,0,1,2.8,1.155A3.32,3.32,0,0,1,18.112-4.318ZM14.051-10.9a1.607,1.607,0,0,0-.65-1.45,3.52,3.52,0,0,0-1.928-.43H7.864v3.749h3.631a3.219,3.219,0,0,0,1.95-.467A1.659,1.659,0,0,0,14.051-10.9Zm.881,6.338q0-2.127-3.051-2.127H7.864v4.34H12a3.609,3.609,0,0,0,2.229-.553A1.982,1.982,0,0,0,14.932-4.565ZM34.859-7.638a8.872,8.872,0,0,1-.935,4.157A6.446,6.446,0,0,1,31.25-.736a8.338,8.338,0,0,1-4.061.951,7.4,7.4,0,0,1-5.591-2.1,7.94,7.94,0,0,1-2.025-5.752,7.728,7.728,0,0,1,2.02-5.683,7.548,7.548,0,0,1,5.618-2.041A7.521,7.521,0,0,1,32.834-13.3,7.732,7.732,0,0,1,34.859-7.638Zm-3.233,0a5.82,5.82,0,0,0-1.16-3.84,4,4,0,0,0-3.255-1.391,4.056,4.056,0,0,0-3.287,1.38,5.811,5.811,0,0,0-1.16,3.851,5.976,5.976,0,0,0,1.187,3.926,3.981,3.981,0,0,0,3.239,1.434,4.018,4.018,0,0,0,3.282-1.4A6.061,6.061,0,0,0,31.626-7.638Z"
          transform="translate(40 22)"
          fill="#ce0909"
        />
      </g>
    </svg>
  );
}

export default BimboIcon;
